import { render, staticRenderFns } from "./UploadAulaModal.vue?vue&type=template&id=e68fbfe8&scoped=true"
import script from "./UploadAulaModal.vue?vue&type=script&lang=js"
export * from "./UploadAulaModal.vue?vue&type=script&lang=js"
import style0 from "./UploadAulaModal.vue?vue&type=style&index=0&id=e68fbfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68fbfe8",
  null
  
)

export default component.exports